import BlogCard from "../../components/Blog/BlogCard";
import React, { useCallback, useEffect, useState } from "react";
import Button from "../../shared/Button";
import { IBlog } from "../../types/blogType";

const BlogPage = () => {
	const [blogs, setBlogs] = useState<Array<IBlog>>([]);

	const fetchBlogs = useCallback(async () => {
		const res = await fetch("/api/blog");
		const { data } = await res.json();
		setBlogs(data);
	}, []);

	useEffect(() => {
		fetchBlogs();
	}, [fetchBlogs]);
	return (
		<div>
			<Button className="bg-white" href={"/dashboard/blog/new"}>
				Add New Blog
			</Button>
			<div className="my-20 grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-y-6 gap-x-6">
				{blogs.map((data) => {
					return <BlogCard data={data} key={data._id} />;
				})}
			</div>
		</div>
	);
};

export default BlogPage;
